import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentPortalTraining`,
  scopes: ExtHubRequest,
});

let entities = [
  { name: 'GetLearningCenter' },
  { name: 'GetLiveTraining' },
  { name: 'GetOnBoarding' },
  { name: 'GetCompliancePortal' },
  { name: 'DownloadICSAsync' },
  { name: 'GetLearningCenterItemsByProduct' },
  { name: 'GetSellingTechniqueList' },
];
api.createEntities(entities);

const GetLearningCenter = () => api.endpoints.GetLearningCenter.post();
const GetLiveTraining = () => api.endpoints.GetLiveTraining.post();
const GetOnBoarding = () => api.endpoints.GetOnBoarding.post();
const GetCompliancePortal = (body) => api.endpoints.GetCompliancePortal.post();
const DownloadICS = (ID) => api.endpoints.DownloadICSAsync.post(ID);
const GetLearningCenterItemsByProduct = (body) =>
  api.endpoints.GetLearningCenterItemsByProduct.post(body);
const GetSellingTechniqueList = () => api.endpoints.GetSellingTechniqueList.post();

export {
  GetLearningCenter,
  GetLiveTraining,
  GetOnBoarding,
  GetCompliancePortal,
  DownloadICS,
  GetLearningCenterItemsByProduct,
  GetSellingTechniqueList,
};
